import React, { useEffect } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import useChatNavigation from "../../../../../Common/useChatNavigation";
import {
  Commas,
  getDateFormate,
} from "../../../../../Common/AllDateTimeReleventFormate";
import { getBxpTogether4 } from "../../../../../../redux/ots/action";
import RentalDetailsLabel from "../../../../../Common/Label/RentalDetailsLabel";
import ProfilePic from "../../../../../../assests/imgs/Profileplaceholder.svg";
import ImageWithFallback from "../../../../../../common/ImageWithFallback";
import ProfileImageWithFallback from "../../../../../../common/ProfileImageWithFallback";

export default function PendingRequests({ postcounts }) {
  const dispatch = useDispatch();
  const { letChat } = useChatNavigation();
  const togeter4 = useSelector(
    ({ ots: { bxptogetherlist4 } }) => bxptogetherlist4
  );

  useEffect(() => {
    dispatch(getBxpTogether4(4));
  }, []);
  let lastDisplayedDate = null;

  return (
    <>
      <div className="posted-project umbrellaproject-sec pending-req">
        <>
          <h4>One Time Services (OTS) ({postcounts?.bxp_history || 0})</h4>
          {Array.isArray(togeter4?.bxp) && togeter4?.bxp?.length > 0 ? (
            <>
              {togeter4?.bxp.map((item, index) => {
                const currentDate = item.created_on.split(" ")[0];
                const shouldDisplayDate = currentDate !== lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && (
                      <h6 className="date-name">
                        {getDateFormate(item.created_on)}
                      </h6>
                    )}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            <ImageWithFallback url={Array.isArray(item?.files) && item?.files[0]?.file} />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <ProfileImageWithFallback url={item?.profile_image} />
                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Seller" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {item?.first_name} {item?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button className="buttons border-button">
                              Decline
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
        <>
          <h4>Buy & Sell with Market (BSM) requests ({postcounts?.sale_history || 0})</h4>
          {Array.isArray(togeter4?.sale) && togeter4?.sale?.length > 0 ? (
            <>
              {togeter4?.sale.map((item, index) => {
                const currentDate = item.created_on.split(" ")[0];
                const shouldDisplayDate = currentDate !== lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && (
                      <h6 className="date-name">
                        {getDateFormate(item.created_on)}
                      </h6>
                    )}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            <ImageWithFallback url={Array.isArray(item?.files) && item?.files[0]?.file} />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <ProfileImageWithFallback url={item?.profile_image} />
                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Seller" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {item?.first_name} {item?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button className="buttons border-button">
                              Decline
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
        <>
          <h4>Turn Assets to Income (TAI) requests ({postcounts?.rental_history || 0})</h4>
          {Array.isArray(togeter4?.rental) && togeter4?.rental?.length > 0 ? (
            <>
              {togeter4?.rental.map((item, index) => {
                const currentDate = item.created_on.split(" ")[0];
                const shouldDisplayDate = currentDate !== lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && (
                      <h6 className="date-name">
                        {getDateFormate(item.created_on)}
                      </h6>
                    )}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            <ImageWithFallback url={Array.isArray(item?.files) && item?.files[0]?.file} />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                              <RentalDetailsLabel item={item} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <ProfileImageWithFallback url={item?.profile_image} />
                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Owner" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {item?.first_name} {item?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button className="buttons border-button">
                              Decline
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
      </div>
    </>
  );
}
